import { Action, createReducer, on } from '@ngrx/store';
import { TournamentsWithPagination } from '../../../tournament/models/tournaments.interface';
import { AllTournamentsActions } from '../actions/action-types.action';

export enum AllTournamentsType {
    Upcoming = 'upcoming',
    Ongoing = 'ongoing',
    Past = 'past',
}

export interface AllTournamentsState {
    upcoming: TournamentsWithPagination;
    ongoing: TournamentsWithPagination;
    past: TournamentsWithPagination;
    isLoading: boolean;
}

const initialState: AllTournamentsState = {
    upcoming: {
        items: [],
        page: 0,
        totalPages: 0,
        isExhausted: false,
        isLoading: false,
    },
    ongoing: {
        items: [],
        page: 0,
        totalPages: 0,
        isExhausted: false,
        isLoading: false,
    },
    past: {
        items: [],
        page: 0,
        totalPages: 0,
        isExhausted: false,
        isLoading: false,
    },
    isLoading: false,
};

const reducer = createReducer(
    initialState,
    on(AllTournamentsActions.fetchAllTournaments, (state, action) => ({
        ...state,
        [action.payload.type]: {
            ...state[action.payload.type],
            isLoading: true,
        },
        isLoading: true,
    })),
    on(AllTournamentsActions.fetchAllTournamentsSuccess, (state, action) => {
        const {
            type,
            response: { items, page, pageSize, total },
        } = action.payload;
        const totalPages = Math.ceil(total / pageSize);
        const isExhausted = page === totalPages;

        return {
            ...state,
            [type]: {
                items: action.payload.patchExistingTournaments
                    ? items
                    : [...state[type].items, ...items],
                page,
                totalPages,
                isExhausted,
                isLoading: false,
            },
            isLoading: false,
        };
    }),
    on(AllTournamentsActions.fetchAllTournamentsFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    }))
);

export const allTournamentsReducer = (
    state: AllTournamentsState,
    action: Action
) => reducer(state, action);
